import { render, staticRenderFns } from "./TheDemographicLegalScreen.vue?vue&type=template&id=4f83cf8a&"
import script from "./TheDemographicLegalScreen.vue?vue&type=script&lang=js&"
export * from "./TheDemographicLegalScreen.vue?vue&type=script&lang=js&"
import style0 from "./TheDemographicLegalScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports